import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconBatteryCharging",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.757 3.071a.5.5 0 0 1 .172.686L4.883 5.5H6a.5.5 0 0 1 .429.757l-1.5 2.5a.5.5 0 0 1-.858-.514L5.117 6.5H4a.5.5 0 0 1-.429-.757l1.5-2.5a.5.5 0 0 1 .686-.172ZM.94 3.44A1.5 1.5 0 0 1 2 3h1a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v3A.5.5 0 0 0 2 8h.5a.5.5 0 0 1 0 1H2A1.5 1.5 0 0 1 .5 7.5v-3c0-.398.158-.78.44-1.06ZM7 3.5a.5.5 0 0 1 .5-.5H8a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 8 9H7a.5.5 0 1 1 0-1h1a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 8 4h-.5a.5.5 0 0 1-.5-.5ZM11 5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 11 5Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  _
];
function m(e, u, r, f, g, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--battery-charging"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Battery Charging",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, h, 10, c);
}
const A = /* @__PURE__ */ o(s, [["render", m]]);
export {
  A as default
};
//# sourceMappingURL=battery-charging.js.map
